<template>
  <div class="container">
    <h1>Timesheets</h1>
    <!-- <div class="get-timesheets">
      <input type="text" id="get-timesheets" v-model="accountId" placeholder="Account ID">
      <v-btn value="Submit" @click="updateTimesheetList">Get Timesheets</v-btn>
    </div> -->
    <p class="error" v-if="error">{{ error }}</p>
    <v-row>
      <v-btn color="success" @click="collateEvents">Collate Events</v-btn>
      <v-btn color="success" @click="postToPayroll">Post to Payroll</v-btn>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="timesheets"
    >
      <template v-slot:[`item.postedToPayroll`]="{ item }">
        <v-simple-checkbox v-model="item.postedToPayroll" disabled></v-simple-checkbox>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TimesheetService from '../services/TimesheetService';
import UserService from '../services/UserService';

export default {
  name: 'TimesheetsView',
  data() {
    return {
      timesheets: [],
      headers: [
        { text: 'Organisation', value: 'org' },
        { text: 'User First Name', value: 'userFirstName' },
        { text: 'User Last Name', value: 'userLastName' },
        { text: 'Start Time', value: 'startTime' },
        { text: 'End Time', value: 'endTime' },
        { text: 'Duration', value: 'durationString' },
        { text: 'Posted To Payroll?', value: 'postedToPayroll' },
      ],
      error: '',
      selectedBusinessId: '',
      user: {},
      userId: this.$auth.user.sub.split('|')[1],
    };
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    this.user = await UserService.getUser(this.userId, token);
    const { businessIds } = this.user;
    if (businessIds.length > 0) {
      [this.selectedBusinessId] = businessIds;
      this.updateTimesheetList();
    }
  },
  methods: {
    async updateTimesheetList() {
      const token = await this.$auth.getTokenSilently();
      TimesheetService.listTimesheets(this.selectedBusinessId, token)
        .then((timesheets) => { this.timesheets = timesheets; })
        .catch(this.reportError);
    },
    async deleteTimesheet(id) {
      const token = await this.$auth.getTokenSilently();
      TimesheetService.deleteTimesheet(id, token)
        .then(() => this.updateTimesheetList())
        .catch(this.reportError);
    },
    async collateEvents() {
      const token = await this.$auth.getTokenSilently();
      TimesheetService.collateTimesheets(this.selectedBusinessId, token)
        .then(() => this.updateTimesheetList())
        .catch(this.reportError);
    },
    async postToPayroll() {
      const token = await this.$auth.getTokenSilently();
      TimesheetService.postTimesheetsToPayroll(this.selectedBusinessId, token)
        .then(() => this.updateTimesheetList())
        .catch(this.reportError);
    },
    reportError(err) {
      this.error = err.message;
    },
  },
};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}

div.timesheet {
  position: relative;
  border: 1px solid #5bd658;
  background-color: 3bcffb8;
  padding: 10px 10px 30px 10px;
  margin-bottom: 15px;
}

p.text {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 0;
}
</style>
